/**
 * RTK Query params serializer - Serializes a params object into a query string
 * format that our backend expects. Mainly used to convert comma-separated
 * values into repeated query parameters.
 *
 * @param params RTK Query params object
 * @returns A serialized string of the params object
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const paramsSerializer = (params: Record<string, any>): string => {
  const searchParams = new URLSearchParams();

  for (const key in params) {
    const value = params[key];

    if (Array.isArray(value)) {
      value.forEach((item) => {
        searchParams.append(`${key}`, item);
      });
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  }

  return searchParams.toString();
};
